import { useState, useMemo, forwardRef, useEffect } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  ListSubheader,
  TextField,
  InputAdornment,
  InputLabel,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface ProjectSelectProps {
  value: string | string[] | [],
  onChange: (e: any) => void,
  list: any,
  width?: string,
  disabled?: any,
  isLabel?: boolean,
  showDefaultProject?: boolean,
}

const ProjectSelect = forwardRef<any, ProjectSelectProps>(({ isLabel = true, showDefaultProject = true, ...props }, _ref) => {
  const [searchText, setSearchText] = useState<string>('');

  const containsText = (text, searchText) =>
    text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

  const filteredProjects = useMemo(
    () =>
      props?.list?.length > 0 &&
      props?.list?.filter((option) => containsText(option?.projectName, searchText)),
    [searchText, props?.list]
  );

  useEffect(() => {
    if(showDefaultProject){
      if (!props.value && props.list?.length > 0) {
        props.onChange({ target: { value: props.list[0].projectId } });
      }
    }
  }, [props.list]);

  return (
    <FormControl className='project-form-control' fullWidth disabled={props?.disabled ? props?.disabled : false}>
      {(props?.value && isLabel) &&
        <InputLabel
          style={{
            fontSize: '12px'
          }}
        >
          Project Name
        </InputLabel>
      }
      <Select
        id="filter-project"
        placeholder="Select Project"
        displayEmpty
        style={{
          width: props?.width ?? '100%',
          fontSize: '12px',
          height: '1.75rem',
          marginTop: '8px'
        }}
        size="small"
        value={props.value ?? ""}
        onChange={(e) => props?.onChange(e)}
        onOpen={() => setSearchText('')}
      >
        <ListSubheader>
          <TextField
            id="search-project"
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          ></TextField>
        </ListSubheader>
        <MenuItem key="" value="" disabled>Select Project</MenuItem>
        {
          filteredProjects?.length > 0 &&
          filteredProjects.map((project, i) => {
            return (
              <MenuItem key={project?.projectId} value={project?.projectId}>{project?.projectName}</MenuItem>
            );
          })
        }
      </Select>
    </FormControl>
  );
});

export default ProjectSelect;
